import React from 'react'

function ProjectItem(props) {
  return (
    <div>
      <div className="card my-3 mx-3" style={{width: "18rem"}}>
  <img src={props.image} className="card-img-top" alt="..."/>
  <div className="card-body">
    <h5 className="card-title">{props.title}</h5>
    <p className="card-text">{props.description}</p>
    <a href={props.link} rel="noreferrer"  target='_blank' className="btn btn-primary">Visit On {props.source}</a>
  </div>
</div>
    </div>
  )
}

export default ProjectItem
